import { Company } from '../../../../hooks/index';
import { SignatureStatus } from '../enums/signature-status.const';
import {
  canSendSignatureReminderForRole,
  isSignatureReminderEligibleStatus,
} from '../utils/can-send-signature-reminder.util';

export const useCanSendSignatureReminder = (status: SignatureStatus): boolean => {
  const { selectedCompany } = Company.useSelected();

  return (
    isSignatureReminderEligibleStatus(status) &&
    canSendSignatureReminderForRole({
      accessRole: selectedCompany?.stakeholder?.accessRole ?? null,
      roleInCompany: selectedCompany?.roleInCompany,
    })
  );
};
